import script from "./SingleColorGen.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleColorGen.vue?vue&type=script&setup=true&lang=js"

import "./SingleColorGen.vue?vue&type=style&index=0&id=7fd8af30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fd8af30"]])

export default __exports__